// Per-race and per-horse comment field. Auto-filled by voice transcription on
// the server (each transcribed note is appended) and editable by the user here.
import { API_BASE_URL } from '../config';
import { authHeader } from './auth';

export type CommentScope = 'race' | 'horse';

export interface CommentContext {
  meetingName?: string;
  raceNumber?: number | string;
  date?: string;
  horseName?: string;
}

export interface EntityComment {
  scope: CommentScope;
  comment: string;
  updated_at: string | null;
}

const buildParams = (scope: CommentScope, ctx: CommentContext): URLSearchParams => {
  const params = new URLSearchParams({ scope });
  if (ctx.meetingName) params.set('meeting_name', ctx.meetingName);
  if (ctx.raceNumber != null && ctx.raceNumber !== '') {
    params.set('race_number', String(ctx.raceNumber));
  }
  if (ctx.date) params.set('date', ctx.date);
  if (ctx.horseName) params.set('horse_name', ctx.horseName);
  return params;
};

export const getComment = async (
  scope: CommentScope,
  ctx: CommentContext
): Promise<EntityComment> => {
  const params = buildParams(scope, ctx);
  const res = await fetch(`${API_BASE_URL}/api/comments?${params.toString()}`, {
    headers: { ...authHeader() },
  });
  if (!res.ok) throw new Error(`Failed to load comment (${res.status})`);
  return res.json();
};

export const saveComment = async (
  scope: CommentScope,
  ctx: CommentContext,
  comment: string
): Promise<EntityComment> => {
  const res = await fetch(`${API_BASE_URL}/api/comments`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({
      scope,
      meeting_name: ctx.meetingName,
      race_number: ctx.raceNumber,
      date: ctx.date,
      horse_name: ctx.horseName,
      comment,
    }),
  });
  if (!res.ok) {
    const detail = await res.text().catch(() => '');
    throw new Error(`Save failed (${res.status}): ${detail.slice(0, 200)}`);
  }
  return res.json();
};
